import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: theme.spacing(1.5),
    padding: theme.spacing(0.5, 1.5),
    border: 'none',
    color: theme.palette.neutral.dark,
    minWidth: 'auto',
  },
  flag: {
    display: 'inline-flex',
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
    flexShrink: 0,

    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export default useStyles
